import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getTaskAvailableColumns } from './api';

export const path = '/ppr/task/list';

const PageTaskListPpr: React.FC = (props) => {
  const TaskListPpr = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getTaskAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <TaskListPpr {...props} />;
};

export default PageTaskListPpr;
